// Ritsu API - Protected image transformation service
const API_BASE_URL = import.meta.env.VITE_API_URL || "https://ritsu-api.mbek9606.workers.dev";

export async function colorizeImage(
  base64Image: string,
  mimeType: string,
  stylePrompt: string,
  variationIndex: number
): Promise<string> {
  const token = localStorage.getItem("auth_token");
  
  if (!token) {
    throw new Error("Please sign in to Ritsu to continue");
  }

  const response = await fetch(`${API_BASE_URL}/api/ai/colorize`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      image: base64Image,
      prompt: stylePrompt,
      seed: variationIndex,
    }),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Please sign in to Ritsu to continue");
    }
    const error = await response.json() as { error: string };
    throw new Error(error.error || "Failed to transform your image");
  }

  const data = await response.json() as { imageUrl: string };
  return data.imageUrl;
}